module.exports = __webpack_public_path__ + "static/media/12.68c80499.png";